<template>

  <div>

    <h1 class="py-8 mb-4">{{ title }}</h1>

    <div v-if="data.actions && data.actions.length">

      <div v-for="section in data.actions">

        <template v-if="section.type === 'va_runnables'">

          <!-- <h2 class="p-2">{{ section.title }}</h2> -->

          <template v-if="section.actions && section.actions.length">

            <div v-for="action in section.actions">

              <a @click.once="applyAction(action)" class="p-2 text-poly-green block cursor-pointer">{{ action.text }}</a>

            </div>

          </template>

        </template>

      </div>

    </div>

    <div class="divider-border"></div>

    <!-- <h6 class="basket-heading-section mb-4">Add an Area</h6> -->
    <AddAreaButtons class="flex flex-col sm:flex-row sm:flex-wrap" />

    <div class="divider-border"></div>

    <div class="text-center sm:text-left">
      <button @click.once="applyAction(summaryAction)" type="button" class="nectar-button cursor-pointer small has-icon">
        <span>GO TO SUMMARY</span>
        <i class="icon-button-arrow" style="line-height:inherit;"></i>
      </button>
    </div>

  </div>

</template>

<script>

import VaCart from '@/components/VaCart.vue'

import AddAreaButtons from '@/components/AddAreaButtons.vue'

import { mapState, mapActions } from 'vuex'

export default {

  name: 'VaWhatsNext',

  components: {
    AddAreaButtons,
    VaCart
  },

  props: {
    data: Object
  },

  computed: {

    ...mapState(['loading', 'stateid']),

    title () {
      let _env = window.env || {};
      return _env.whats_next_title || '';
    },

    summaryAction () {
      return {
        'action': 'go_to_report',
        'stateid': this.stateid
      }
    }

  },

  methods: {
    ...mapActions(['applyAction'])
  }

}
</script>
